
import ShieldSlash from "../../../assets/duotone/ShieldSlash.svg";

import { IconProps } from "../../../types";

const cx = require('classnames');

export default function ShieldSlashIcon({ className, dataTestid = "ShieldSlashIcon", ...rest }: IconProps) {
  const classes = cx(className);

  return (
    <ShieldSlash data-testid={dataTestid} className={classes} {...rest} />
  );
}
